import posthog, { type PostHogConfig } from 'posthog-js';

const DISTINCT_ID_STORAGE_KEY = 'posthog_bootstrap_distinct_id';

function getOrCreateDistinctId(): string {
  const existingDistinctId = window.localStorage.getItem(DISTINCT_ID_STORAGE_KEY);
  if (existingDistinctId) {
    return existingDistinctId;
  }

  const distinctId = window.crypto.randomUUID();
  window.localStorage.setItem(DISTINCT_ID_STORAGE_KEY, distinctId);
  return distinctId;
}

function shouldDisableSessionRecording(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return true;
  }

  try {
    if (window.top && window.top !== window.self) {
      const topOrigin = window.top.location.origin;
      if (topOrigin !== window.location.origin) {
        return true;
      }
    }
  } catch {
    return true;
  }

  const iframes = document.getElementsByTagName('iframe');
  for (const iframe of Array.from(iframes)) {
    try {
      const _body = iframe.contentDocument?.body;
      void _body;
    } catch {
      return true;
    }
  }

  return false;
}

function getPostHogOptions(): Partial<PostHogConfig> {
  return {
    api_host: process.env.POSTHOG_HOST,
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-05-30',
    bootstrap: {
      distinctID: getOrCreateDistinctId(),
      isIdentifiedID: false,
    },
    persistence: 'localStorage+cookie',
    opt_out_capturing_by_default: true,
    person_profiles: 'always',
    autocapture: false,
    capture_pageview: true,
    disable_session_recording: shouldDisableSessionRecording(),
    loaded: (ph) => {
      ph.register({ app: 'vocab-test' });
    },
    session_recording: {
      recordCrossOriginIframes: false,
      collectFonts: false,
    },
  } satisfies Partial<PostHogConfig>;
}

export function initPostHogClient(): typeof posthog {
  const apiKey = process.env.POSTHOG_KEY;
  if (!apiKey) {
    return posthog;
  }

  posthog.init(apiKey, getPostHogOptions());

  return posthog;
}
